/**
 * Historial de las últimas reuniones con asistencia real guardada (hoja de asistencia).
 */
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { cellMeetingTimeLabel } from "@/lib/cellFormLabels";
import { formatMeetingDateDisplay, weekdayLabelFromIso } from "@/lib/cellMeetingSchedule";

/**
 * @param {{
 *   items: Array,
 *   loading?: boolean,
 *   onViewMeeting?: (meetingDate: string) => void,
 * }} props
 */
export function CellMeetingCompletedHistory({ items = [], loading = false, onViewMeeting }) {
  return (
    <Card className="border-gray-200 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg text-gray-900">Historial de reuniones realizadas</CardTitle>
        <CardDescription>
          Últimas 4 reuniones registradas para la célula seleccionada.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {loading ? (
          <p className="text-sm text-gray-500 py-3 text-center">Cargando historial…</p>
        ) : !items.length ? (
          <p className="text-sm text-gray-500 py-3 text-center">
            Aún no hay reuniones registradas para esta célula.
          </p>
        ) : (
          <ul className="space-y-2">
            {items.map((h) => {
              const md = h.meeting_date || "";
              const day = weekdayLabelFromIso(md);
              const time = h.meeting_time ? cellMeetingTimeLabel(h.meeting_time) : null;
              const att = h.total_asistentes ?? 0;
              const tot = h.total_convocados ?? 0;
              const pct = h.porcentaje_asistencia ?? 0;
              return (
                <li
                  key={md}
                  className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-gray-100 bg-gray-50 px-3 py-2.5 text-sm"
                >
                  <div className="min-w-0 space-y-0.5">
                    <p className="font-medium text-gray-900">
                      {formatMeetingDateDisplay(md)}
                      {day ? ` — ${day}` : ""}
                      {time && time !== "Sin hora" ? ` — ${time}` : ""}
                    </p>
                    <p className="text-gray-700">
                      <span className="text-indigo-800 font-medium">
                        {att} de {tot} asistentes — {pct}%
                      </span>
                      {h.meeting_suspended ? (
                        <Badge
                          variant="outline"
                          className="ml-2 bg-amber-50 text-amber-900 border-amber-200 text-xs"
                        >
                          Suspendida
                        </Badge>
                      ) : null}
                    </p>
                  </div>
                  {typeof onViewMeeting === "function" ? (
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      className="h-8 shrink-0"
                      onClick={() => onViewMeeting(md)}
                    >
                      Ver asistencia
                    </Button>
                  ) : null}
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
